/**
 * Translation Class
 *
 * @example
 * // simple
 * i18n.t('playtech.mobile.system.tooltip.number')
 *
 * @example
 * // with parameters
 * i18n.t('playtech.mobile.system.tooltip.welcome', 'John', 21)
 * // In this case 'playtech.mobile.system.tooltip.welcome' should contain placeholders for values:
 * // 'Hi {0}. Your age: {1}'
 *
 * @example
 * // with default value
 * i18n.tExt('playtech.mobile.system.mobile-cashier.error.' + errorCode, 'Cashier error');
 * // In this case if we fail to find translation for ('playtech.mobile.system.mobile-cashier.error.' + errorCode) we use
 * // 'Cashier error' as translation
 *
 *
 * You may use 'showTranslationKeys' url param to force show translation keys on UI.
 * It can help track untranslated keys.
 * `showTranslationKeys` shows translations keys, default values and replacers on UI
 * Not found translation keys will be logged to browser console
 *
 */

define(function(require, exports, module) {
    'use strict';

    var Class = require('Class');
    var util = require('utils');
    var logger = require('util/logger.util');

    var TranslationClass = Class.create({

        initialize: function() {
            // Feature for testing: can help detect untranslated hardcoded strings
            const showTranslationKeys = new URLSearchParams(location.search).has('showTranslationKeys');

            if (showTranslationKeys) {
                this.t = (key, ...params) => this.showTranslationKey(key, params);
                this.tExt = this.showTranslationKey;
            } else {
                this.t = this.translate;
                this.tExt = this.translateExt;
            }

            this.translations = {};
            this.pageTranslations = {};
            this.systemTranslations = {};
            this.pageInPopupTranslations = {};
        },

        setSystemTranslations: function(translations) {
            this.systemTranslations = { ...translations };

            this.translations = { ...this.systemTranslations, ...this.pageInPopupTranslations, ...this.pageTranslations };
        },

        setPageTranslations: function(translations) {
            this.pageTranslations = { ...translations };

            this.translations = { ...this.systemTranslations, ...this.pageInPopupTranslations, ...this.pageTranslations };
        },

        setPageInPopupTranslations: function(translations) {
            this.pageInPopupTranslations = { ...translations };

            this.translations = { ...this.systemTranslations, ...this.pageInPopupTranslations, ...this.pageTranslations };
        },

        translate: function(key) {
            let value = this.translations[key] ?? key;

            if (arguments[1] !== undefined) {
                const params = Array.prototype.slice.call(arguments);

                params[0] = value;
                value = util.string.format.apply(this, params);
            }

            return value;
        },

        translateExt: function(key, defaultValue) {
            var value = this.t(key);

            return value !== key ? value : defaultValue ?? key;
        },

        showTranslationKey: function(key, params) {
            const isDefaultValue = typeof params === 'string';
            const isReplacers = Boolean(Array.isArray(params) && params.length);

            if (this.translations[key] == null) {
                logger.warn('NO TRANSLATION: ' + key);
            }

            return [
                key,
                isDefaultValue && params !== key && `(${params})`,
                isReplacers && `[${params.join(', ')}]`
            ].filter(Boolean).join(' ');
        },

        t: null,

        tExt: null
    });

    /**
     * @type TranslationClass
     */
    module.exports = TranslationClass;
});
